import React, { useContext, lazy } from 'react';
import { Link } from 'react-router-dom';
import 'swiper/css';
import classes from '../Main.module.scss';
import { GeneralContext } from '../../../context/generalContext';
import { addressesAPI, lambicClubLinkAPI } from '../../../services/GeneralService';
import qrCodeRu from '../../../images/qr-app-ru.png';
import qrCodeEn from '../../../images/qr-app-en.png';
import qrCodeUz from '../../../images/qr-code-uz.png';
import qrCodeNkz from '../../../images/qr-code-nkz.png';
import qrLogo from '../../../images/main-lambic-logo.svg';

const MainClubMobile = lazy(() => import('../MainClubMobile/MainClubMobile'));

const goToTop = () => {
  window.scrollTo({
    top: 0,
  });
};

export default function MainClubSection() {
  const { activeLanguage, activeCity, selectedAddress, subdomainIsActive } = useContext(GeneralContext);
  const { data: addresses } = addressesAPI.useFetchAllAddressesQuery();
  const { data: clubLink } = lambicClubLinkAPI.useFetchAllLabicClubLinkQuery();

  const clubNumUz = 70000;

  return (
    <section className={classes.clubSection}>
      <div className={classes.clubPercent} />

      <div className={`${classes.clubBox} ${classes.onlyDesktop}`}>
        <div className={classes.clubAbout}>
          <div className={classes.clubLabel}>
            {activeLanguage === 1 ? 'Клуб привилегий Lambic' : 'Lambic privileges club'}
          </div>
          {activeCity === 6 ? (
            <>
              <div className={classes.clubTitle}>
                {activeLanguage === 1
                  ? `Дарим ${clubNumUz.toLocaleString()} сум при установке карты Lambic Club`
                  : `We give you ${clubNumUz.toLocaleString()} UZS when you install a Lambic Club card`}
              </div>
              <div className={classes.clubDesc}>
                {activeLanguage === 1
                  ? 'Накопительная программа скидок и бонусов! Вступайте в клуб, установив себе электронную карту, и получайте:'
                  : 'An accumulative program of discounts and bonuses! Join the club by setting up your e-card and get discounts:'}
              </div>
            </>
          ) : (
            <>
              <div className={classes.clubTitle}>
                {activeLanguage === 1
                  ? 'Дарим 300 рублей при установке карты Lambic Club'
                  : 'We give you 300 rubles when you install a Lambic Club card'}
              </div>
              <div className={classes.clubDesc}>
                {activeLanguage === 1
                  ? 'Накопительная программа скидок и бонусов! Вступайте в клуб, установив себе электронную карту, и получайте:'
                  : 'An accumulative program of discounts and bonuses! Join the club by setting up your e-card and get discounts:'}
              </div>
            </>
          )}
          <div className={classes.clubFeatures}>
            <ul>
              <li>
                {activeLanguage === 1 ? 'Скидки' : 'Discounts'}
                <br />
                {activeLanguage === 1 ? 'и бонусы' : 'and bonuses'}
              </li>
              <li>
                {activeLanguage === 1 ? 'Специальные' : 'Special'}
                <br />
                {activeLanguage === 1 ? 'предложения' : 'offers'}{' '}
              </li>
              <li>
                {activeLanguage === 1 ? 'Возможность участия' : 'Ability to participate'}
                <br />
                {activeLanguage === 1 ? 'в розыгрышах' : 'raffles'}{' '}
              </li>
            </ul>
          </div>
          {clubLink?.length > 0 && (
            <div className={classes.clubBtnBox}>
              <Link
                className={`${classes.btn} ${classes.btnBlue}`}
                to={activeLanguage === 1 ? `${clubLink}` : `/en${clubLink}`}
                onClick={goToTop}
              >
                {activeLanguage === 1 ? 'Подробнее о клубе привилегий' : 'Read more about the Privilege Club'}
              </Link>
            </div>
          )}
        </div>
        <div className={classes.clubQr}>
          <div className={classes.clubLabel}>
            {activeLanguage === 1 ? 'приложение brasserie lambic' : 'brasserie lambic app'}
          </div>
          <div className={classes.clubQrCode}>
            {activeCity === 5 && <img className={classes.clubQrCodeImg} src={qrCodeNkz} alt='' />}
            {activeCity === 6 && <img className={classes.clubQrCodeImg} src={qrCodeUz} alt='' />}
            {activeCity !== 6 && activeCity !== 5 && (
              <img className={classes.clubQrCodeImg} src={activeLanguage === 1 ? qrCodeRu : qrCodeEn} alt='' />
            )}
            <img
              className={classes.qrLogo}
              src={
                subdomainIsActive
                  ? addresses?.filter(address => address.id === selectedAddress)[0]?.logo_lambic_club || qrLogo
                  : qrLogo
              }
              alt='logo'
            />
          </div>
          <div className={classes.clubQrSteps}>
            <ol>
              <li>
                {activeLanguage === 1
                  ? 'Наведите мобильное устройство  на QR-код.'
                  : 'Point your mobile device at the QR code.'}
              </li>
              <li>
                {activeLanguage === 1
                  ? 'Установите приложение (Доступно для Android и iOS).'
                  : 'Install the app (Available for Android and iOS).'}
              </li>
              <li>
                {activeLanguage === 1
                  ? 'Загрузите в приложение электронную карту, чтобы получать скидки, бонусы, специальные предложения и возможность участия в розыгрышах призов!'
                  : 'Download your e-card to the app to receive discounts, bonuses, special offers and the opportunity to participate in prize drawings!'}
              </li>
            </ol>
          </div>
        </div>
      </div>

      <MainClubMobile clubNumUz={clubNumUz} />
    </section>
  );
}
